import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, Share2, X } from "lucide-react";
import { sharePhoto } from "@/components/lightbox/sharePhoto";

export function LightboxTopBar({ index, count, photo, onClose }) {
  return (
    <div className="flex items-center justify-between px-4 sm:px-6 py-3 text-slate-300 text-xs font-mono uppercase tracking-widest">
      <span data-testid="lightbox-counter">{index + 1} / {count}</span>
      <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
        <button type="button" onClick={() => sharePhoto(photo)} className="flex items-center gap-2 px-3 py-2 rounded-full hover:bg-white/10 transition-colors" aria-label="Share this photo" data-testid="lightbox-share">
          <Share2 className="w-5 h-5" /> <span className="hidden sm:inline">Share</span>
        </button>
        <button type="button" onClick={onClose} className="p-2 rounded-full hover:bg-white/10 transition-colors" aria-label="Close" data-testid="lightbox-close">
          <X className="w-6 h-6" />
        </button>
      </div>
    </div>
  );
}

export function LightboxNavButton({ dir, onStep }) {
  const next = dir > 0;
  return (
    <button type="button" onClick={(e) => { e.stopPropagation(); onStep(dir); }} aria-label={next ? "Next photo" : "Previous photo"} data-testid={next ? "lightbox-next" : "lightbox-prev"}
      className={`absolute ${next ? "right-2 sm:right-4" : "left-2 sm:left-4"} top-1/2 -translate-y-1/2 p-3 rounded-full bg-black/50 border border-white/15 text-white hover:bg-cyan-500 hover:text-slate-900 transition-colors`}>
      {next ? <ChevronRight className="w-6 h-6" /> : <ChevronLeft className="w-6 h-6" />}
    </button>
  );
}

export function LightboxCaption({ photo: p }) {
  return (
    <div className="px-4 sm:px-6 py-4 max-w-3xl w-full mx-auto text-center" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center justify-center gap-2 mb-2 flex-wrap">
        {p.before && <span className="dg-chip">Before / after</span>}
        {p.tag && <span className="dg-chip">{p.tag}</span>}
        {p.installed && <span className="dg-chip text-[#FFD600] border-[#FFD600]/50">Installed by David</span>}
      </div>
      <h3 className="text-base md:text-lg font-semibold text-white" data-testid="lightbox-title">{p.title}</h3>
      {p.subtitle && <p className="text-sm text-slate-400 mt-1" data-testid="lightbox-subtitle">{p.subtitle}</p>}
      {p.id && <Link to={`/project/${p.id}`} className="dg-link text-sm mt-2 inline-block" data-testid="lightbox-details">Project details →</Link>}
    </div>
  );
}
